// BS26 "B26 join" REG page — on-the-list calendar button + referral card logic.
// Loaded ONLY when section setting reg_mode is true (sections/lp-bs26-b26-join.liquid gates the <script> tag), so the
// live (non-REG) signup page never loads this file and its behavior is unchanged.
// Two copies of the referral card exist in the DOM (mobile inline after the grid, desktop inside aside#lp-card) —
// every handler below uses event delegation + closest('.b26j-ref') so either copy works without id clashes.
// Calendar: Google Calendar link (Android/desktop) vs an .ics download (iOS — Google Calendar web links do not open
// the Calendar app there). This page never loads bs26-sale-list-quiz-result-render.js, so it cannot reuse
// window.SLQ_RESULT.calendar() — this file is the REG page's own calendar logic. hero-sticky.js's own [data-lp-cal]
// click handler is guarded to skip window.SLQ_RESULT when it is not loaded, so the two scripts do not collide.
(function () {
  const C = window.SLQ_CONFIG, T = window.SLQ_TRACK || { listAction() {} };
  const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  // ── Add the sale to my calendar ──
  function icsDownload() {
    const ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', 'DTSTART:' + C.sale.calStart, 'DTEND:' + C.sale.calEnd,
      `SUMMARY:${C.brand} sale opens (65%-80% off)`, `URL:${location.origin}${C.joinUrl || '/pages/b26-join'}`,
      'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
    const a = document.createElement('a');
    a.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics); a.download = 'sale.ics'; a.click();
  }
  function gcalUrl() {
    const text = encodeURIComponent(`${C.brand} sale opens (65%-80% off)`);
    const details = encodeURIComponent(`Private access. ${C.sale.open}.`);
    return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${text}&dates=${C.sale.calStart}/${C.sale.calEnd}&details=${details}`;
  }
  function addToCalendar() { if (isIOS()) icsDownload(); else window.open(gcalUrl(), '_blank', 'noopener'); }

  // ── Referral: always points at the non-REG signup page, never this REG page ──
  const refUrl = () => location.origin + (C.refUrl || '/pages/b26-join?utm_source=referral&utm_medium=share&utm_campaign=bs26-b26-ref');
  const refText = () => (C.shareText || '').replace('{url}', refUrl());
  document.querySelectorAll('[data-b26j-ref-url]').forEach((el) => { el.value = refUrl(); });

  function showCopied(fromEl) {
    const card = fromEl.closest('.b26j-ref'), status = card && card.querySelector('[data-b26j-ref-status]');
    if (status) status.textContent = 'Link copied ✓';
  }
  async function copyLink(fromEl) {
    try { await navigator.clipboard.writeText(refUrl()); } catch (_) {
      // Clipboard API unavailable/blocked (older browser, no permission) — legacy textarea + execCommand fallback.
      const t = document.createElement('textarea');
      t.value = refUrl(); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (_) { /* best effort */ }
      t.remove();
    }
    showCopied(fromEl);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-lp-cal]')) { T.listAction('b26j-reg', 'calendar'); addToCalendar(); return; }
    const share = e.target.closest('[data-b26j-ref-share]');
    if (share) {
      T.listAction('b26j-ref', 'share');
      if (navigator.share) navigator.share({ text: refText() }).catch(() => {});
      else copyLink(share); // no native share sheet → copy, same as the spec's fallback
      return;
    }
    const copy = e.target.closest('[data-b26j-ref-copy]');
    if (copy) { T.listAction('b26j-ref', 'copy'); copyLink(copy); return; }
    const sms = e.target.closest('[data-b26j-ref-sms]');
    if (sms) { T.listAction('b26j-ref', 'sms'); location.href = 'sms:?&body=' + encodeURIComponent(refText()); }
  });
})();
